import { ViewportScroller } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Section } from 'src/app/model/shared/section';

@Component({
  selector: 'app-section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.scss']
})
export class SectionComponent implements OnInit {
  @Input() param: string | undefined;
  @Input() sections: Section[] = [];
  @Input() isIAGPortalDocumentationPage: boolean = false;
  @Input() isNDCManagement: boolean = false;
  @Input() gettingStartedPage: boolean = false;
  alreadyScrolled: boolean = false;

  constructor(private scroller: ViewportScroller) {}

  ngOnInit(): void {
    if (this.param) {
      // console.log('param : ', this.param);
    }
  }

  isSelected(key: string) {
    const isSelected = key === this.param || key === this.param + '?';
    if (isSelected && !this.alreadyScrolled) {
      this.scroller.scrollToAnchor(key);
      this.alreadyScrolled = true;
    }
    return isSelected;
  }
}
